import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  getAllRestaurantsApi,
  getRestaurantDetailsApi,
} from "../../api/adminRestaurantApi";

export const getAllRestaurants =
  createAsyncThunk(
    "admin/restaurants",
    async (
      search,
      { rejectWithValue }
    ) => {
      try {
        const response =
          await getAllRestaurantsApi(
            search
          );

        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data
        );
      }
    }
  );

  export const getRestaurantDetails =
  createAsyncThunk(
    "admin/getRestaurantDetails",
    async (
      id,
      { rejectWithValue }
    ) => {
      try {
        const response =
          await getRestaurantDetailsApi(
            id
          );

        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data
        );
      }
    }
  );

const initialState = {
  restaurants: [],
  restaurantDetails: null,
  loading: false,
  error: null,
};

const adminRestaurantSlice =
  createSlice({
    name: "adminRestaurant",

    initialState,

    reducers: {},

    extraReducers: (builder) => {
      builder
        .addCase(
          getAllRestaurants.pending,
          (state) => {
            state.loading = true;
          }
        )

        .addCase(
          getAllRestaurants.fulfilled,
          (state, action) => {
            state.loading = false;

            state.restaurants =
              action.payload.restaurants;
          }
        )

        .addCase(
          getAllRestaurants.rejected,
          (state, action) => {
            state.loading = false;

            state.error =
              action.payload?.message;
          }
        )

        .addCase(
  getRestaurantDetails.pending,
  (state) => {
    state.loading = true;
  }
)

.addCase(
  getRestaurantDetails.fulfilled,
  (state, action) => {
    state.loading = false;
    state.restaurantDetails =
      action.payload.restaurant;
  }
)

.addCase(
  getRestaurantDetails.rejected,
  (state, action) => {
    state.loading = false;
    state.error =
      action.payload?.message;
  }
)
    },
  });

export default
  adminRestaurantSlice.reducer;